import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function PasswordResetSuccess() {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: 'center' }}>
      <Typography variant="h5" align="center" sx={{ marginBottom: 10 }}>
        {t('password_reset_success')}
      </Typography>
      <Link to={'/login'} style={{ alignSelf: 'center' }}>{t('return_to_login')}</Link>
    </div>
  );
}
